<client-termination-reasons-modal *ngIf="modalVisible"></client-termination-reasons-modal>

<mat-spinner *ngIf="loading" class="inline-material-spinner" [diameter]="100"></mat-spinner>

<section class="header" data-dd-privacy="allow">
  <div class="header-left">
    <p class="helper-text">
      <iris-icon name="info_outline"></iris-icon>
      Clients will see changes you make to their contact information.
    </p>
  </div>
  <div class="header-right"></div>
</section>
<form class="form" [formGroup]="form" *ngIf="!loading">
  <iris-card>
    <h3>Client Info</h3>

    <div class="client-info-container">
      <iris-form-field class="first-name" label="Legal First Name" [showOptionalTag]="false" >
        <iris-text-input type="text" formControlName="firstName" placeholder="Legal First Name">
        </iris-text-input>
      </iris-form-field>

      <iris-form-field class="last-name" label="Legal Last Name" [showOptionalTag]="false" >
        <iris-text-input type="text" formControlName="lastName" placeholder="Legal Last Name">
        </iris-text-input>
      </iris-form-field>

      <iris-form-field class="gender" [showOptionalTag]="false" label="Gender" [customErrorMessages]="$any(form.get('genderId'))">
        <iris-dropdown
          [options]="genderOptions"
          formControlName="genderId"
          placeholder="Select gender"
        >
        </iris-dropdown>
      </iris-form-field>

      <iris-form-field 
        label="Date of birth"
        class="date-of-birth"
        data-test="date-of-birth-label"
        [customErrorMessages]="{
          dateFormat: 'Dates must be in correct format of MM/DD/YYYY Month/Day/Year.' 
        }"
        [showOptionalTag]="false"
      >
        <iris-text-input 
          formControlName="dateOfBirth"
          type="date"
          [dropSpecialCharacters]="false"
          data-test="date-of-birth"
        ></iris-text-input>
      </iris-form-field>

      <iris-form-field class="email" label="Email" [showOptionalTag]="false">
        <iris-text-input type="text" placeholder="Email" formControlName="email">
        </iris-text-input>
      </iris-form-field>

      <iris-form-field class="cell-phone" label="Cell Phone" [showOptionalTag]="false">
        <iris-text-input type="text" placeholder="Cell Phone" formControlName="cellPhone" [mask]="_maskingService.ngxMaskPhoneNumber">
        </iris-text-input>
      </iris-form-field>
      <iris-form-field class="home-phone" label="Home Phone" [showOptionalTag]="false">
        <iris-text-input type="text" placeholder="Home Phone" formControlName="homePhone" [mask]="_maskingService.ngxMaskPhoneNumber">
        </iris-text-input>
      </iris-form-field>

      <div *ngIf="form.errors?.nameMissing && form.touched" class="error-list alert alert-danger">
        A first or last name is required!
      </div>
    </div>
      
    <br>
    <mat-divider></mat-divider>
    <br>

    <h3>Home Address</h3>

    <div class="client-address-container">
      <iris-form-field class="address-1" label="Address Line 1" [showOptionalTag]="false" >
        <iris-text-input type="text" placeholder="Address Line 1" formControlName="addressLine1">
        </iris-text-input>
      </iris-form-field>

      <iris-form-field class="address-2" label="Address Line 2" [showOptionalTag]="false">
        <iris-text-input type="text" placeholder="Address Line 2" formControlName="addressLine2">
        </iris-text-input>
      </iris-form-field>

      <iris-form-field class="city" label="City" [showOptionalTag]="false">
        <iris-text-input type="text" formControlName="city" placeholder="City">
        </iris-text-input>
      </iris-form-field>

      <iris-form-field class="state" label="State" [showOptionalTag]="false" [customErrorMessages]="$any(form.get('state'))">
        <iris-dropdown [options]="usStateNamesOptions" formControlName="state" placeholder="Select state">
        </iris-dropdown>
      </iris-form-field>

      <iris-form-field class="postal" label="Postal Code" [showOptionalTag]="false">
        <iris-text-input type="text" formControlName="postalCode" placeholder="Postal Code">
        </iris-text-input>
      </iris-form-field>
    </div>

    <div class="client-actions-container">
      <iris-button-container *ngIf="patient.nonSpnPatient || patient.accountRequired || patient.accountPending">
        <iris-button *ngIf="patient.nonSpnPatient" [buttonType]="irisButtonTypes.PRIMARY" (click)="billViaSondermind()">Bill via Sondermind</iris-button>
        <iris-button *ngIf="patient.accountRequired" [buttonType]="irisButtonTypes.PRIMARY" (click)="accountRequired()">Resend invite</iris-button>
        <iris-button *ngIf="patient.accountPending" [buttonType]="irisButtonTypes.PRIMARY" (click)="accountPending()">Account pending for claim, send reminder</iris-button>
      </iris-button-container>
        
      <iris-button-container>
        @if (!saving) {
          <iris-button [buttonType]="irisButtonTypes.TERTIARY" (click)="handleCancel()">Reset changes</iris-button>
        }
        <iris-button   
          [buttonType]="patient.active ? irisButtonTypes.DANGER : irisButtonTypes.PRIMARY" 
          (click)="patient.active ? handleInactiveClick(patient) : handleActiveClick(patient)"
        >
          {{patient.active ? "Mark as inactive" : "Reactivate"}}
        </iris-button>

        <save-button-material [saving]="saving" (buttonClicked)="handleSave($event)" [disabled]="saving || !form.valid"></save-button-material>
      </iris-button-container>
    </div>

  </iris-card>
</form>

<br>

<iris-card *ngIf="!loading">
  <h3 class="contacts-header">
    <div>
      Contacts
    </div>
    <div>
      <iris-icon-button
        icon="plus_circle"
        [type]="irisIconButtonTypes.TERTIARY"
        ariaLabel="Add Contact" 
        data-test="add-contact-button"
        class="add-contact-button"
        (click)="handleCreateContact($event)" 
      ></iris-icon-button>
    </div>

  </h3>
  <div>
    <clients-contact-list [patient]="patient" [patientContacts]="patientContacts" [loading]="loading" (patientContactsChanged)="reloadContacts()"></clients-contact-list>
    <clients-contact-modal [patient]="patient"></clients-contact-modal>
  </div>
</iris-card>

<sondermind-alert-modal></sondermind-alert-modal>
<sondermind-confirmation-modal></sondermind-confirmation-modal>
